import { useCallback, useContext } from "react";
import { useNavigate } from "react-router";

import type { MoveState } from "../components/notice.js";

import { isAppPage, LeaveContext } from "./navigation.js";

/**
 * 行き先へ移る。<b>React が描ける画面なら画面の中で、無ければページごと</b>移る
 * （まだ静的になっていない画面や公開ページは、SWA が別のファイルを返す）。
 * 添える値（通知・アドレス）は画面の中で移るときだけ渡る（URL には載せない）。
 */
export const useGo = (): ((location: string, state?: MoveState) => void) => {
    const navigate = useNavigate();
    const leave = useContext(LeaveContext);

    return useCallback((location: string, state?: MoveState) => {
        if (isAppPage(location)) {
            void navigate(location, { state });
        } else {
            leave(location);
        }
    }, [navigate, leave]);
};
